// File location with status codes: 'backend/src/server/lib/status/status.go'
// (hover over the const for value)
// note: The bitwise code for Draft = 128

// Assign the status name to their bitwise equivalent
const ReadyForReviewStatusCode = 64
const CompletedStatusCode = 256

export default {
  methods: {
    checkPostStatus: function (post) {
      if (post.postStatus) {
        const postStatus = post.postStatus.status
        // Bitwise operator '&' comparison method used below for the postStatus and status code comparison
        if (postStatus & ReadyForReviewStatusCode) {
          return 'ReadyForReview'
        } else if (postStatus & CompletedStatusCode) {
          return 'Completed'
        } else {
          return 'Draft'
        }
      } else {
        return 'Draft'
      }
    }
  }
}
